import { StepStoryboard } from "@/components/marketing/StepStoryboard";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-surface-1">
      <div className="container px-4">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">
            How it works
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold mt-3 mb-5">
            Three steps. Zero complexity.
          </h2>
          <p className="text-base md:text-lg text-muted-foreground">
            From inbox to a structured contact in seconds — without leaving Outlook.
          </p>
        </div>

        <div className="max-w-6xl">
          <StepStoryboard />
        </div>
      </div>
    </section>
  );
};
